"use strict";

let tabactive = 1;
let tabactiveold = 1;

let activeform1, activeform2;


//Language
var url = window.location.href;
if(url.indexOf("/en/") !== -1) {
    var lang = "en";
} else {
    var lang = "de";
}

/********************************
 *      Constants
 ********************************/
let fsd = 435;
let kc = 0.55;

let tol = 0.00001;

var config = {
    modeBarButtonsToRemove: [
        'sendDataToCloud',
        'toImage',
        'select2d',
        'lasso2d',
        'hoverClosestCartesian',
        'hoverCompareCartesian',
        'autoScale2d',
        'toggleSpikelines',
    ],
    responsive: true,
    displaylogo: false,
};

let init = 1;

/********************************
 *      Applied Stresses
 ********************************/
let sigmax, sigmaz, sigmax1, sigmaz1, sigmax2, sigmaz2;
let tauxz1, alpha1;
let tauxz_ult, alpha_ult;


let rhox, rhoz, rhox2, rhoz2;
let sigma_cx_ult, sigma_cz_ult, sigma_c1_ult, sigma_c3_ult;
let sigma_sx_ult, sigma_sz_ult;
let regime;

let sigma_sx, sigma_sz;
let sigma_cx, sigma_cz;
let sigma_c1, sigma_c3;

let tauxz, alpha, fc;
let k;

sigmax = parseFloat($("#sigmax1").val());
sigmaz = parseFloat($("#sigmaz1").val());
tauxz_ult = parseFloat($("#tauxz1").val());
alpha_ult = 45;

let sigmax1_local = parseFloat($("#sigmax1").val());
let sigmaz1_local = parseFloat($("#sigmaz1").val());
let tauxz1_local = parseFloat($("#tauxz1").val());
let alpha1_local = 45;

let sigmax2_local = parseFloat($("#sigmax2").val());
let sigmaz2_local = parseFloat($("#sigmaz2").val());
let rhox2_local = parseFloat($("#rhox2").val());
let rhoz2_local = parseFloat($("#rhoz2").val());


/*********************
 *      Concrete
 *********************/
const concrete = Mat.Concrete.types
const reinforcement = Mat.Reinforcement.steelTypes;


//Concrete Parameters
let cType = parseFloat($("#conType").val());
let fcd = concrete[cType].fcd;

let sType = parseFloat($("#refType").val());



//UpDate Concrete Type
// Update of the concrete strenth from Dropdown Menu
$("#conType").change(function () {
    cType = parseFloat($("#conType").val());
    fcd = concrete[cType].fcd;

    $("#conFcd").html(concrete[cType].fcd);
    $("#conFc").html(math.round(concrete[cType].fcd * 0.55 * 100) / 100);

    let Ec = Math.round(Math.pow(concrete[cType].fcm, (1 / 3)) * 100) / 10;
    $("#conEc").html(Ec);

    updCalc();
    updPlots();
    updateHTML();
    console.log("contype")

}
);

//UpDate Concrete Type
// Update of the concrete strenth from Dropdown Menu
$("#refType").change(function () {
    sType = parseFloat($("#refType").val());
    if (sType == 0) {
        fsd = 435;
    } else {
        fsd = 610;
    }


    $("#steelFsd").html(fsd);
    $("#fsdDesign").html(fsd);

    updCalc();
    updPlots();
    updateHTML();

}
);




/********************************
 *      Reinforcement
 ********************************/

/********************************
 *      Update Text in HTML
 ********************************/
function updateHTML() {

    if (tabactive == 1) {
        $("#rhoxmin").html(math.round(rhox * 10000) / 100);
        $("#rhozmin").html(math.round(rhoz * 10000) / 100);
        $("#fcmin").html(math.round(fc * 100) / 100);

        $("#k").html(math.round(k * 100) / 100);

    } else {


        if (sigmax <= rhox * fsd && sigmax >= -fc - rhox * fsd && sigmaz <= rhoz * fsd && sigmaz >= -fc - rhoz * fsd) {

            if(lang == "en") {
                var text = '<b>Failure mode</b>:<br>For the applied normal stresses of σ<sub><i>x</i></sub> = ' + sigmax.toString() + ' MPa and σ<sub><i>z</i></sub> = ' + sigmaz.toString() + ' MPa, the membrane element fails at the shear stress τ<sub><i>xz</i></sub> = ' + (math.round(tauxz_ult * 100) / 100).toString() + ' MPa, where ';
                var failuretext;

                switch (regime) {
                    case 1:
                        failuretext = "both reinforcements yield in tension";
                        break;
                    case 2:
                        failuretext = "the <i>z</i>-reinforcement yields in tension and the concrete crushes";
                        break;
                    case 3:
                        failuretext = "the <i>x</i>-reinforcement yields in tension and the concrete crushes";
                        break;
                    case 4:
                        failuretext = "the concrete crushes";
                        break;
                    case 5:
                        failuretext = "the <i>x</i>-reinforcement yields in compression and the concrete crushes";
                        break;
                    case 6:
                        failuretext = "the <i>z</i>-reinforcement yields in compression and the concrete crushes";
                        break;
                    case 7:
                        failuretext = "both reinforcements yield in compression and the concrete crushes";
                        break;
                }
            } else {
                var text = '<b>Versagensart</b>:<br>Bei gegebenen Normalspannungen von σ<sub><i>x</i></sub> = ' + sigmax.toString() + ' MPa und σ<sub><i>z</i></sub> = ' + sigmaz.toString() + ' MPa versagt die Scheibe bei der Schubspannung τ<sub><i>xz</i></sub> = ' + (math.round(tauxz_ult * 100) / 100).toString() + ' MPa, wobei ';
                var failuretext;

                switch (regime) {
                    case 1:
                        failuretext = "beide Bewehrungen auf Zug fliessen";
                        break;
                    case 2:
                        failuretext = "die <i>z</i>-Bewehrung auf Zug fliesst und der Beton bricht";
                        break;
                    case 3:
                        failuretext = "die <i>x</i>-Bewehrung auf Zug fliesst und der Beton bricht";
                        break;
                    case 4:
                        failuretext = "der Beton bricht";
                        break;
                    case 5:
                        failuretext = "die <i>x</i>-Bewehrung auf Druck fliesst und der Beton bricht";
                        break;
                    case 6:
                        failuretext = "die <i>z</i>-Bewehrung auf Druck fliesst und der Beton bricht";
                        break;
                    case 7:
                        failuretext = "beide Bewehrungen auf Druck fliessen und der Beton bricht";
                        break;
                }
            }
            
            $("#htmlfailuretext").html(text + failuretext + '<b> (Regime ' + regime.toString() + ') </b>.');
        } else {
            if(lang == "en") {
                var text = 'The applied normal stresses of σ<sub><i>x</i></sub> = ' + sigmax.toString() + ' MPa and σ<sub><i>z</i></sub> = ' + sigmaz.toString() + ' MPa cannot be resisted by the membrane.';
            } else {
                var text = 'Die gegebenen Normalspannungen von σ<sub><i>x</i></sub> = ' + sigmax.toString() + ' MPa und σ<sub><i>z</i></sub> = ' + sigmaz.toString() + ' MPa können von der Scheibe nicht aufgenommen werden.';
            }
            
            $("#htmlfailuretext").html(text);
        }
    }
}


/********************************
 *      Calc functions
 ********************************/
$('.nav-tabs a').on('shown.bs.tab', function (event) {
    let tab = $(event.target).attr('id');
    if (tab == "design") {
        tabactive = 1;

    }
    if (tab == "verification") {
        tabactive = 2;

    }


    if (tabactive !== tabactiveold) {

        updCalc();
        updPlots();
        updateHTML();

    }
    if (tab == "design") {
        tabactiveold = 1;
    }
    if (tab == "verification") {
        tabactiveold = 2;
    }
})

// check entries for Bemessung
$("#sigmax1").on("change", function (event) {
    let sigmax1_old = sigmax1_local;
    sigmax1_local = parseFloat($("#sigmax1").val());
    if (isNaN(sigmax1_local)) {
        sigmax1_local = sigmax1_old;
        document.getElementById('sigmax1').classList.add('is-invalid');
        document.getElementById('CtrlDesign_Input').classList.add('focus');
        setTimeout(function () {
            if(lang == "en") {
                alert('The input is not a number.');
            } else {
                alert(["Die Eingabe ist keine Zahl."]);
            }
            
            document.getElementById('sigmax1').classList.remove('is-invalid');
            document.getElementById('CtrlDesign_Input').classList.remove('focus');
            $("#sigmax1").val(sigmax1_local);
        }, 10)
        return
    }

    activeform1 = 'sigmax1';
    updCalc();
    updPlots();
    updateHTML();
});

$("#sigmaz1").on("change", function (event) {
    let sigmaz1_old = sigmaz1_local;
    sigmaz1_local = parseFloat($("#sigmaz1").val());
    if (isNaN(sigmaz1_local)) {
        sigmaz1_local = sigmaz1_old;
        document.getElementById('sigmaz1').classList.add('is-invalid');
        document.getElementById('CtrlDesign_Input').classList.add('focus');
        setTimeout(function () {
            if(lang == "en") {
                alert('The input is not a number.');
            } else {
                alert(["Die Eingabe ist keine Zahl."]);
            }
            document.getElementById('sigmaz1').classList.remove('is-invalid');
            document.getElementById('CtrlDesign_Input').classList.remove('focus');
            $("#sigmaz1").val(sigmaz1_local);
        }, 10)
        return
    }

    activeform1 = 'sigmaz1';
    updCalc();
    updPlots();
    updateHTML();
});

$("#tauxz1").on("change", function (event) {
    let tauxz1_old = tauxz1_local;
    tauxz1_local = parseFloat($("#tauxz1").val());
    if (isNaN(tauxz1_local)) {
        tauxz1_local = tauxz1_old;
        document.getElementById('tauxz1').classList.add('is-invalid');
        document.getElementById('CtrlDesign_Input').classList.add('focus');
        setTimeout(function () {
            if(lang == "en") {
                alert('The input is not a number.');
            } else {
                alert(["Die Eingabe ist keine Zahl."]);
            }
            document.getElementById('tauxz1').classList.remove('is-invalid');
            document.getElementById('CtrlDesign_Input').classList.remove('focus');
            $("#tauxz1").val(tauxz1_local);
        }, 10)
        return
    }
    activeform1 = 'tauxz1';
    updCalc();
    updPlots();
    updateHTML();
});
$("#alpha1").on("change", function (event) {
    let alpha1_old = alpha1_local;
    alpha1_local = parseFloat($("#alpha1").val());
    if (isNaN(alpha1_local)) {
        alpha1_local = alpha1_old;
        document.getElementById('alpha1').classList.add('is-invalid');
        document.getElementById('CtrlDesign_Input').classList.add('focus');
        setTimeout(function () {
            if(lang == "en") {
                alert('The input is not a number.');
            } else {
                alert(["Die Eingabe ist keine Zahl."]);
            }
            document.getElementById('alpha1').classList.remove('is-invalid');
            document.getElementById('CtrlDesign_Input').classList.remove('focus');
            $("#alpha1").val(alpha1_local);
        }, 10)
        return
    }
    $("#k").html(math.round(math.cot(alpha1_local / 180 * math.pi) * 100) / 100);
    slideralpha.noUiSlider.set(alpha1_local);
});

var slideralpha = document.getElementById('slideralpha');
noUiSlider.create(slideralpha, {
    start: [45],
    range: {
        'min': [0],
        'max': [90]
    },
    tooltips: false,
    step: 0.1,
    pips: {
        mode: 'count',
        values: 7,
        density: 30
    },
    format: wNumb({
        decimals: 1,
    })
});

slideralpha.noUiSlider.on('set', function () {
    activeform1 = 'alpha1';
    alpha1_local = slideralpha.noUiSlider.get();
    $("#alpha1").val(slideralpha.noUiSlider.get());
    updCalc();
    updPlots();
    updateHTML();
});

slideralpha.noUiSlider.on('slide', function () {
    $("#alpha1").val(slideralpha.noUiSlider.get());
    $("#k").html(math.round(math.cot(slideralpha.noUiSlider.get() / 180 * math.pi) * 100) / 100);
});

// check entries for Überprüfung
$("#sigmax2").on("change", function (event) {
    let sigmax2_old = sigmax2_local;
    sigmax2_local = parseFloat($("#sigmax2").val());
    if (isNaN(sigmax2_local)) {
        sigmax2_local = sigmax2_old;
        document.getElementById('sigmax2').classList.add('is-invalid');
        document.getElementById('CtrlCheck_Input').classList.add('focus');
        setTimeout(function () {
            if(lang == "en") {
                alert('The input is not a number.');
            } else {
                alert(["Die Eingabe ist keine Zahl."]);
            }
            document.getElementById('sigmax2').classList.remove('is-invalid');
            document.getElementById('CtrlCheck_Input').classList.remove('focus');
            $("#sigmax2").val(sigmax2_local);
        }, 10)
        return
    }

    activeform2 = 'sigmax2';
    updCalc();
    updPlots();
    updateHTML();
});
$("#sigmaz2").on("change", function (event) {
    let sigmaz2_old = sigmaz2_local;
    sigmaz2_local = parseFloat($("#sigmaz2").val());
    if (isNaN(sigmaz2_local)) {
        sigmaz2_local = sigmaz2_old;
        document.getElementById('sigmaz2').classList.add('is-invalid');
        document.getElementById('CtrlCheck_Input').classList.add('focus');
        setTimeout(function () {
            if(lang == "en") {
                alert(["The input is not a number."]);
            } else {
                alert(["Die Eingabe ist keine Zahl."]);
            }
            
            document.getElementById('sigmaz2').classList.remove('is-invalid');
            document.getElementById('CtrlCheck_Input').classList.remove('focus');
            $("#sigmaz2").val(sigmaz2_local);
        }, 10)
        return
    }
    activeform2 = 'sigmaz2';
    updCalc();
    updPlots();
    updateHTML();
});
$("#rhox2").on("change", function (event) {
    let rhox2_old = rhox2_local;
    rhox2_local = parseFloat($("#rhox2").val());
    if (isNaN(rhox2_local)) {
        rhox2_local = rhox2_old;
        document.getElementById('rhox2').classList.add('is-invalid');
        document.getElementById('CtrlCheck_Input').classList.add('focus');
        setTimeout(function () {
            if(lang == "en") {
                alert(["The input is not a number."]);
            } else {
                alert(["Die Eingabe ist keine Zahl."]);
            }
            document.getElementById('rhox2').classList.remove('is-invalid');
            document.getElementById('CtrlCheck_Input').classList.remove('focus');
            $("#rhox2").val(rhox2_local);
        }, 10)
        return
    }
    activeform2 = 'rhox2';
    updCalc();
    updPlots();
    updateHTML();
});
$("#rhoz2").on("change", function (event) {
    let rhoz2_old = rhoz2_local;
    rhoz2_local = parseFloat($("#rhoz2").val());
    if (isNaN(rhoz2_local)) {
        rhoz2_local = rhoz2_old;
        document.getElementById('rhoz2').classList.add('is-invalid');
        document.getElementById('CtrlCheck_Input').classList.add('focus');
        setTimeout(function () {
            if(lang == "en") {
                alert(["The input is not a number."]);
            } else {
                alert(["Die Eingabe ist keine Zahl."]);
            }
            document.getElementById('rhoz2').classList.remove('is-invalid');
            document.getElementById('CtrlCheck_Input').classList.remove('focus');
            $("#rhoz2").val(rhoz2_local);
        }, 10)
        return
    }
    activeform2 = 'rhoz2';
    updCalc();
    updPlots();
    updateHTML();
});

function updCalc() {

    if (tabactive == 1) { //BEMESSUNG

        // old values
        var sigmax1_old = sigmax1;
        var sigmaz1_old = sigmaz1;
        var tauxz1_old = tauxz1;
        var alpha1_old = alpha1;

        var k_old = math.cot(alpha1 / 180 * math.pi);
        var rhox_old = (sigmax1 + k_old * tauxz1) / fsd;
        var rhoz_old = (sigmaz1 + 1 / k_old * tauxz1) / fsd;

        var warning_threshold = 3 / 100;
        var error_threshold = 5 / 100;

        // new values
        sigmax1 = parseFloat($("#sigmax1").val());
        sigmaz1 = parseFloat($("#sigmaz1").val());
        tauxz1 = parseFloat($("#tauxz1").val());
        alpha1 = slideralpha.noUiSlider.get();

        k = math.cot(alpha1 / 180 * math.pi);
        rhox = (sigmax1 + k * tauxz1) / fsd;
        rhoz = (sigmaz1 + 1 / k * tauxz1) / fsd;


        // check conditions
        if (rhox >= error_threshold) {
            sigmax1 = sigmax1_old;
            sigmaz1 = sigmaz1_old;
            tauxz1 = tauxz1_old;
            alpha1 = alpha1_old;

            k = k_old;
            rhox = rhox_old;
            rhoz = rhoz_old;

            document.getElementById(activeform1).classList.add('is-invalid');
            document.getElementById('CtrlDesign_Input').classList.add('focus');
            setTimeout(function () {
                if(lang == "en") {
                    alert('The reinforcement ratio in x-direction is above 5% and therefore not relevant in practice.\n\nPlease change the parameters.');
                } else {
                    alert('Der Bewehrungsgehalt in x-Richtung liegt über 5% und ist somit nicht praxisrelevant.\n\nBitte ändere die Parameter.');
                }
                
                $("#sigmax1").val(sigmax1);
                $("#sigmaz1").val(sigmaz1);
                $("#tauxz1").val(tauxz1);
                $("#alpha1").val(alpha1);
                slideralpha.noUiSlider.set(alpha1);
            }, 10)
            return
        } else {
            document.getElementById('sigmax1').classList.remove('is-invalid');
            document.getElementById('sigmaz1').classList.remove('is-invalid');
            document.getElementById('tauxz1').classList.remove('is-invalid');
            document.getElementById('alpha1').classList.remove('is-invalid');
            document.getElementById('CtrlDesign_Input').classList.remove('focus');
        }

        if (rhoz >= error_threshold) {
            sigmax1 = sigmax1_old;
            sigmaz1 = sigmaz1_old;
            tauxz1 = tauxz1_old;
            alpha1 = alpha1_old;

            k = k_old;
            rhox = rhox_old;
            rhoz = rhoz_old;

            document.getElementById(activeform1).classList.add('is-invalid');
            document.getElementById('CtrlDesign_Input').classList.add('focus');
            setTimeout(function () {
                if(lang == "en") {
                    alert('The reinforcement ratio in z-direction is above 5% and therefore not relevant in practice.\n\nPlease change the parameters.');
                } else {
                    alert('Der Bewehrungsgehalt in z-Richtung liegt über 5% und ist somit nicht praxisrelevant. \n\nBitte ändere die Parameter.');
                }
                
                $("#sigmax1").val(sigmax1);
                $("#sigmaz1").val(sigmaz1);
                $("#tauxz1").val(tauxz1);
                $("#alpha1").val(alpha1);
                slideralpha.noUiSlider.set(alpha1);
            }, 10)
            return
        } else {
            document.getElementById('sigmax1').classList.remove('is-invalid');
            document.getElementById('sigmaz1').classList.remove('is-invalid');
            document.getElementById('tauxz1').classList.remove('is-invalid');
            document.getElementById('alpha1').classList.remove('is-invalid');
            document.getElementById('CtrlDesign_Input').classList.remove('focus');
        }

        if (rhox < 0 || rhoz < 0) {

            sigmax1 = sigmax1_old;
            sigmaz1 = sigmaz1_old;
            tauxz1 = tauxz1_old;
            alpha1 = alpha1_old;

            k = k_old;
            rhox = rhox_old;
            rhoz = rhoz_old;

            document.getElementById(activeform1).classList.add('is-invalid');
            document.getElementById('CtrlDesign_Input').classList.add('focus');
            setTimeout(function () {
                if(lang == "en") {
                    alert('The membrane element cannot be designed in regime 1 for the given parameters.');
                } else {
                    alert('Die Scheibe kann für die gegebenen Parameter nicht in Regime 1 bemessen werden.');
                }

                $("#sigmax1").val(sigmax1);
                $("#sigmaz1").val(sigmaz1);
                $("#tauxz1").val(tauxz1);
                $("#alpha1").val(alpha1);
                slideralpha.noUiSlider.set(alpha1);
            }, 10)

            return
        } else {
            document.getElementById('sigmax1').classList.remove('is-invalid');
            document.getElementById('sigmaz1').classList.remove('is-invalid');
            document.getElementById('tauxz1').classList.remove('is-invalid');
            document.getElementById('alpha1').classList.remove('is-invalid');
            document.getElementById('CtrlDesign_Input').classList.remove('focus');
        }

        if (rhox >= warning_threshold && rhox < error_threshold) {
            document.getElementById('rhoxmin').style.background = "orange";
            setTimeout(function () {
                if(lang == "en") {
                    alert('Attention: High reinforcement ratio over 3% in x-direction!');
                } else {
                    alert('Achtung: Hoher Bewehrungsgehalt über 3% in x-Richtung!');
                }

            }, 10)
        } else {
            document.getElementById('rhoxmin').style.background = "transparent";
        }
        if (rhoz >= warning_threshold && rhoz < error_threshold) {
            document.getElementById('rhozmin').style.background = "orange";
            setTimeout(function () {
                if(lang == "en") {
                    alert('Attention: High reinforcement ratio over 3% in z-direction!');
                } else {
                    alert('Achtung: Hoher Bewehrungsgehalt über 3% in z-Richtung!');
                }
            }, 10)
        } else {
            document.getElementById('rhozmin').style.background = "transparent";
        }

        // assign to global variables
        sigmax = sigmax1;
        sigmaz = sigmaz1;
        tauxz_ult = tauxz1;
        alpha_ult = alpha1;

        k = math.cot(alpha_ult / 180 * math.pi);
        rhox = (sigmax + k * tauxz_ult) / fsd;
        rhoz = (sigmaz + 1 / k * tauxz_ult) / fsd;
        fc = rhox * fsd + rhoz * fsd - (sigmax + sigmaz);




    } else { // ÜBERPRÜFUNG

        // old values
        var sigmax2_old = sigmax2;
        var sigmaz2_old = sigmaz2;

        var rhox2_old = rhox2;
        var rhoz2_old = rhoz2;

        // new values
        sigmax2 = parseFloat($("#sigmax2").val());
        sigmaz2 = parseFloat($("#sigmaz2").val());

        rhox2 = parseFloat($("#rhox2").val()) / 100;
        rhoz2 = parseFloat($("#rhoz2").val()) / 100;

        fc = fcd * kc;

        if (sigmax2 <= rhox2 * fsd && sigmax2 >= -fc - rhox2 * fsd && sigmaz2 <= rhoz2 * fsd && sigmaz2 >= -fc - rhoz2 * fsd) { }
        else {
            sigmax2 = sigmax2_old;
            sigmaz2 = sigmaz2_old;
            rhox2 = rhox2_old;
            rhoz2 = rhoz2_old;
            setTimeout(function () {
                if(lang == "en") {
                    alert('The applied normal stresses cannot be resisted by the membrane element.');
                } else {
                    alert('Die gegebenen Normalspannungen können von der Scheibe nicht aufgenommen werden.');
                }

                $("#sigmax2").val(sigmax2);
                $("#sigmaz2").val(sigmaz2);
                $("#rhox2").val(rhox2 * 100);
                $("#rhoz2").val(rhoz2 * 100);
            }, 10);
            return
        }

        // assign to global variables
        sigmax = sigmax2;
        sigmaz = sigmaz2;
        rhox = rhox2;
        rhoz = rhoz2;
    }

    alpha = [
        math.acot(math.sqrt((rhox * fsd - sigmax) / (rhoz * fsd - sigmaz))) * 180 / math.pi,
        math.acot(math.sqrt((fc - rhoz * fsd + sigmaz) / (rhoz * fsd - sigmaz))) * 180 / math.pi,
        math.acot(math.sqrt((rhox * fsd - sigmax) / (fc - rhox * fsd + sigmax))) * 180 / math.pi,
        math.acot(math.sqrt(1)) * 180 / math.pi,
        math.acot(math.sqrt(-(rhox * fsd + sigmax) / (fc + rhox * fsd + sigmax))) * 180 / math.pi,
        math.acot(math.sqrt(-(fc + rhoz * fsd + sigmaz) / (rhoz * fsd + sigmaz))) * 180 / math.pi,
        math.acot(math.sqrt((fc + rhoz * fsd + sigmaz) / (fc + rhox * fsd + sigmax))) * 180 / math.pi,
    ];


    tauxz = [
        math.sqrt((rhox * fsd - sigmax) * (rhoz * fsd - sigmaz)),
        math.sqrt((fc - rhoz * fsd + sigmaz) * (rhoz * fsd - sigmaz)),
        math.sqrt((rhox * fsd - sigmax) * (fc - rhox * fsd + sigmax)),
        math.sqrt(math.pow(fc / 2, 2)),
        math.sqrt(-(rhox * fsd + sigmax) * (fc + rhox * fsd + sigmax)),
        math.sqrt(-(fc + rhoz * fsd + sigmaz) * (rhoz * fsd + sigmaz)),
        math.sqrt((fc + rhox * fsd + sigmax) * (fc + rhoz * fsd + sigmaz)),
    ];

    let delta_sigma_c31 = math.dotDivide(tauxz, math.dotMultiply(math.sin(math.dotMultiply(alpha, math.pi / 180)), math.cos(math.dotMultiply(alpha, math.pi / 180))));

    sigma_c3 = math.subtract(0, delta_sigma_c31);
    sigma_c3[6] = -fc;

    sigma_c1 = math.add(sigma_c3, delta_sigma_c31);

    sigma_cx = math.add(sigma_c3, math.dotMultiply(math.tan(math.dotMultiply(alpha, math.pi / 180)), tauxz));
    sigma_cz = math.add(sigma_c3, math.dotMultiply(math.cot(math.dotMultiply(alpha, math.pi / 180)), tauxz));

    sigma_sx = math.dotDivide(math.subtract(sigmax, sigma_cx), rhox);
    sigma_sz = math.dotDivide(math.subtract(sigmaz, sigma_cz), rhoz);

    var i;
    tauxz_ult = 0;
    regime = 0;
    for (i = 0; i < 7; i++) {
        if (tauxz[i] > tauxz_ult &&
            sigma_c3[i] > (-fc - tol) &&
            sigma_c1[i] < 0 + tol &&
            sigma_sx[i] >= (-fsd - tol) &&
            sigma_sx[i] <= (fsd + tol) &&
            sigma_sz[i] >= (-fsd - tol) &&
            sigma_sz[i] <= (+fsd + tol)) {
            regime = i + 1;
            tauxz_ult = tauxz[i];
            alpha_ult = alpha[i];
            sigma_cx_ult = sigma_cx[i];
            sigma_cz_ult = sigma_cz[i];
            sigma_c1_ult = sigma_c1[i];
            sigma_c3_ult = sigma_c3[i];
            sigma_sx_ult = sigma_sx[i];
            sigma_sz_ult = sigma_sz[i];
        }
    }


}

function updPlots() {

    plot3D();
    plotStressState();
    plotElement();
}

function principledir(x, z, xz) {
    let twophi1 = math.atan2(xz, (x - z) / 2);
    phi1 = twophi1 / 2;
    phi1 = phi1 * 180 / math.pi;
    return phi1;
}

/*******************************
 *      Plotting of 3D Element
 *******************************/

function plotStressState() {
    /*
     Draw Mohr Circle
      */


    let temp_Mohr = new Group();
    let layout_Mohr;

    if (sigmax <= rhox * fsd && sigmax >= -fc - rhox * fsd && sigmaz <= rhoz * fsd && sigmaz >= -fc - rhoz * fsd) {
        // applied force
        let m = (sigmax + sigmaz) / 2; // Centre of Mohr Circle
        let r_a = math.sqrt(math.pow((sigmax - sigmaz) / 2, 2) + math.pow(tauxz_ult, 2)); // Radius of Mohr Circle
        let markersize = 0.02 * r_a;
        temp_Mohr.addElm(new Circle(m, 0, r_a).setColor(col.forces.getRgb()));

        temp_Mohr.addElm(new Circle(sigmax, tauxz_ult, markersize).setColor(col.forces.getRgb()).setFill(col.forces.getRgba()));
        temp_Mohr.addElm(new Circle(sigmaz, -tauxz_ult, markersize).setColor(col.forces.getRgb()).setFill(col.forces.getRgba()));
        temp_Mohr.addElm(new Circle(sigmax, -tauxz_ult, markersize).setColor(col.forces.getRgb()).setFill(col.forces.getRgba()));
        temp_Mohr.addElm(new Line([sigmax, sigmax], [tauxz_ult, -tauxz_ult]).setColor(col.forces.getRgb()));
        temp_Mohr.addElm(new Line([sigmaz, sigmax], [-tauxz_ult, -tauxz_ult]).setColor(col.forces.getRgb()));

        // concrete
        m = (sigma_cx_ult + sigma_cz_ult) / 2; // Centre of Mohr Circle
        let r_c = math.sqrt(math.pow((sigma_cx_ult - sigma_cz_ult) / 2, 2) + math.pow(tauxz_ult, 2)); // Radius of Mohr Circle
        temp_Mohr.addElm(new Circle(m, 0, r_c).setColor(col.c.getRgb()));

        // xz
        temp_Mohr.addElm(new Circle(sigma_cx_ult, tauxz_ult, markersize).setColor(col.c.getRgb()).setFill(col.c.getRgba()));
        temp_Mohr.addElm(new Circle(sigma_cz_ult, -tauxz_ult, markersize).setColor(col.c.getRgb()).setFill(col.c.getRgba()));
        temp_Mohr.addElm(new Circle(sigma_cx_ult, -tauxz_ult, markersize).setColor(col.c.getRgb()).setFill(col.c.getRgba()));
        temp_Mohr.addElm(new Line([sigma_cx_ult, sigma_cx_ult], [tauxz_ult, -tauxz_ult]).setColor(col.c.getRgb()));
        temp_Mohr.addElm(new Line([sigma_cz_ult, sigma_cx_ult], [-tauxz_ult, -tauxz_ult]).setColor(col.c.getRgb()));

        // 13
        temp_Mohr.addElm(new Circle(sigma_c1_ult, 0, markersize).setColor(col.c.getRgb()).setFill(col.c.getRgba()));
        temp_Mohr.addElm(new Circle(sigma_c3_ult, 0, markersize).setColor(col.c.getRgb()).setFill(col.c.getRgba()));
        temp_Mohr.addElm(new Line([sigma_c1_ult, sigma_cx_ult], [0, -tauxz_ult]).setColor(col.c.getRgb()));
        temp_Mohr.addElm(new Line([sigma_c3_ult, sigma_cx_ult], [0, -tauxz_ult]).setColor(col.c.getRgb()));

        // Principal Angle
        temp_Mohr.addElm(new Circle(-sigma_c1_ult, 0, r_c * 0.3, alpha_ult).rotate(180));
        let phiround = math.round(alpha_ult * 10) / 10;
        temp_Mohr.addElm(new Text(sigma_c1_ult - math.cos(-alpha_ult / 180 / 2 * math.pi) * 0.4 * r_c - 0.2 * r_c, -math.sin(alpha_ult / 180 / 2 * math.pi) * r_c * 0.4, ["α = " + phiround.toString() + "°"]));

        // fc
        temp_Mohr.addElm(new Line([-fc, -fc], [-2000, 2000]).setColor(col.c.getRgb()).setDash('dashdot'));
        let fc_round = math.round(fc * 100) / 100;
        if (tabactive == 1) {
            temp_Mohr.addElm(new Text(-fc * 0.8, (sigma_c1_ult - sigma_c3_ult) / 2 * 1.3, ["<i>f</i><sub>c,min</sub></i> = " + fc_round.toString() + " MPa"]));
            temp_Mohr.addElm(new Text(-fc * 0.8, (sigma_c1_ult - sigma_c3_ult) / 2 * 1.3, ["<i>f</i><sub><i>c</i>,min</sub> = " + fc_round.toString() + " MPa"]));
        } else {
            temp_Mohr.addElm(new Text(-fc * 0.8, (sigma_c1_ult - sigma_c3_ult) / 2 * 1.3, ["<i>f<sub>c</sub></i> = " + fc_round.toString() + " MPa"]));
        }
        // steel
        // check steel stress in x-direction
        var dashx = 'solid';
        let re = [1, 3, 5, 7];
        if (re.includes(regime)) {
            dashx = 'dashdot'
        }
        ;
        // check steel stress in z-direction
        var dashz = 'solid';
        re = [1, 2, 6, 7];
        if (re.includes(regime)) {
            dashz = 'dashdot'
        }
        ;

        temp_Mohr.addElm(new Line([sigma_cx_ult, sigmax], [tauxz_ult, tauxz_ult]).setColor(col.s.getRgb()).setDash(dashx));
        temp_Mohr.addElm(new Line([sigma_cz_ult, sigmaz], [-tauxz_ult, -tauxz_ult]).setColor(col.s.getRgb()).setDash(dashz));

        let sigma_sx_round = math.round(sigma_sx_ult * 10) / 10;
        temp_Mohr.addElm(new Text((sigma_cx_ult + sigmax) / 2, tauxz_ult * 1.1, ["σ<sub><i>sx</i></sub> = " + sigma_sx_round.toString() + " MPa"]));
        let sigma_sz_round = math.round(sigma_sz_ult * 10) / 10;
        temp_Mohr.addElm(new Text((sigma_cz_ult + sigmaz) / 2, -tauxz_ult * 1.13, ["σ<sub><i>sz</i></sub> = " + sigma_sz_round.toString() + " MPa"]).setColor(col.s.getRgb()));

        layout_Mohr = {
            hovermode: false,
            height: 350,
            //width: 700,
            autosize: true,
            margin: {
                l: 40,
                r: 20,
                b: 40,
                t: 10,
                pad: 0
            },
            xaxis: {
                title: 'σ [MPa]',
                domain: [0, 1],
                //rangemode: 'tozero',
                autorange: true,
                zeroline: true,
                autotick: true,
                //range: [m-2*r,m+2*r],
            },
            yaxis: {
                title: 'τ [MPa]',
                domain: [0, 1],
                rangemode: 'tozero',
                zeroline: true,
                scaleanchor: "x",
                scaleratio: 1,
                range: math.dotMultiply([-1, 1], 1.4 * math.max(r_c, r_a)),
            },
            showlegend: false,
        };
    } else {
        layout_Mohr = {
            hovermode: false,
            height: 350,
            //width: 700,
            autosize: true,
            margin: {
                l: 40,
                r: 20,
                b: 40,
                t: 10,
                pad: 0
            },
            xaxis: {
                title: 'σ [MPa]',
                domain: [0, 1],
                //rangemode: 'tozero',
                autorange: true,
                zeroline: true,
                autotick: true,
                //range: [m-2*r,m+2*r],
            },
            yaxis: {
                title: 'τ [MPa]',
                domain: [0, 1],
                rangemode: 'tozero',
                zeroline: true,
                scaleanchor: "x",
                scaleratio: 1,

            },
            showlegend: false,
        };
    }
    // Plot Mohr Circle
    let pltSec = temp_Mohr.getPlotData();
    var data = pltSec.data;
    Plotly.newPlot('plot_Mohr', data, layout_Mohr, config);



}

/*******************************
 *      Plotting of 3D Element
 *******************************/

let rhox_old = 0;
let rhoz_old = 0;
let fsd_old = 0;
let fc_old = 0;

function plot3D() {
    let res = 200;

    if (rhox_old !== rhox || rhoz_old !== rhoz || fsd_old !== fsd || fc_old !== fc) {

        var x_data = [];
        var y_data = [];
        var z_data = [];
        var regime_data = [];
        var regime_text = [];

        for (var i = 0; i < res; i++) {

            x_data[i] = [];
            y_data[i] = [];
            z_data[i] = [];
            regime_data[i] = [];
            regime_text[i] = [];
            for (var j = 0; j < res; j++) {
                x_data[i][j] = -rhox * fsd - fc + i / (res - 1) * (fc + 2 * rhox * fsd);
                y_data[i][j] = -rhoz * fsd - fc + j / (res - 1) * (fc + 2 * rhoz * fsd);


                //Regime 1
                if (x_data[i][j] + y_data[i][j] >= rhox * fsd + rhoz * fsd - fc) {
                    z_data[i][j] = math.re(math.sqrt((rhox * fsd - x_data[i][j]) * (rhoz * fsd - y_data[i][j])));
                    regime_data[i][j] = 0.5;
                    if(lang == "en") {
                        regime_text[i][j] = "α = " + math.round(math.acot(math.sqrt((rhox * fsd - x_data[i][j]) / (rhoz * fsd - y_data[i][j]))) * 180 / math.pi * 100) / 100 + " °<br><br>Regime 1:<br>Both reinforcements yield in tension.";
                    } else {
                        regime_text[i][j] = "α = " + math.round(math.acot(math.sqrt((rhox * fsd - x_data[i][j]) / (rhoz * fsd - y_data[i][j]))) * 180 / math.pi * 100) / 100 + " °<br><br>Regime 1:<br>Beide Bewehrungen fliessen auf Zug.";
                    }

                }

                // Regime 2
                if (x_data[i][j] + y_data[i][j] < rhox * fsd + rhoz * fsd - fc && y_data[i][j] >= rhoz * fsd - fc / 2 && x_data[i][j] + y_data[i][j] >= rhoz * fsd - rhox * fsd - fc) {
                    z_data[i][j] = math.re(math.sqrt((fc - rhoz * fsd + y_data[i][j]) * (rhoz * fsd - y_data[i][j])));
                    regime_data[i][j] = 2;
                    if(lang == "en") {
                        regime_text[i][j] = "α = " + math.round(math.acot(math.sqrt((fc - rhoz * fsd + y_data[i][j]) / (rhoz * fsd - y_data[i][j]))) * 180 / math.pi * 100) / 100 + " °<br><br>Regime 2:<br><i>z</i>-reinforcement yields in tension; Concrete crushes";
                    } else {
                        regime_text[i][j] = "α = " + math.round(math.acot(math.sqrt((fc - rhoz * fsd + y_data[i][j]) / (rhoz * fsd - y_data[i][j]))) * 180 / math.pi * 100) / 100 + " °<br><br>Regime 2:<br><i>z</i>-Bewehrung fliesst auf Zug; Beton bricht";
                    }
                }

                // Regime 3
                if (x_data[i][j] + y_data[i][j] < rhox * fsd + rhoz * fsd - fc && x_data[i][j] >= rhox * fsd - fc / 2 && x_data[i][j] + y_data[i][j] >= rhox * fsd - rhoz * fsd - fc) {
                    z_data[i][j] = math.re(math.sqrt((fc - rhox * fsd + x_data[i][j]) * (rhox * fsd - x_data[i][j])));
                    regime_data[i][j] = 3;
                    if(lang == "en") {
                        regime_text[i][j] = "α = " + math.round(math.acot(math.sqrt((rhox * fsd - x_data[i][j]) / (fc - rhox * fsd + x_data[i][j]))) * 180 / math.pi * 100) / 100 + " °<br><br>Regime 3:<br><i>x</i>-reinforcement yields in tension; Concrete crushes";
                    } else {
                        regime_text[i][j] = "α = " + math.round(math.acot(math.sqrt((rhox * fsd - x_data[i][j]) / (fc - rhox * fsd + x_data[i][j]))) * 180 / math.pi * 100) / 100 + " °<br><br>Regime 3:<br><i>x</i>-Bewehrung fliesst auf Zug; Beton bricht";
                    }
                    
                }

                // Regime 4
                if (x_data[i][j] < rhox * fsd - fc / 2 && x_data[i][j] >= -rhox * fsd - fc / 2 && y_data[i][j] < rhoz * fsd - fc / 2 && y_data[i][j] >= -rhoz * fsd - fc / 2) {
                    z_data[i][j] = fc / 2;
                    regime_data[i][j] = 4;
                    if(lang == "en") {
                        regime_text[i][j] = "α = " + math.round(math.acot(math.sqrt(1)) * 180 / math.pi * 100) / 100 + " °<br><br>Regime 4:<br>Concrete crushes";
                    } else {
                        regime_text[i][j] = "α = " + math.round(math.acot(math.sqrt(1)) * 180 / math.pi * 100) / 100 + " °<br><br>Regime 4:<br>Beton bricht";
                    }
                }

                // Regime 5
                if (x_data[i][j] + y_data[i][j] < rhoz * fsd - rhox * fsd - fc && x_data[i][j] + y_data[i][j] >= -rhoz * fsd - rhox * fsd - fc && x_data[i][j] < -rhox * fsd - fc / 2) {
                    z_data[i][j] = math.re(math.sqrt(-(rhox * fsd + x_data[i][j]) * (fc + rhox * fsd + x_data[i][j])));
                    regime_data[i][j] = 5;
                    if(lang == "en") {
                        regime_text[i][j] = "α = " + math.round(math.acot(math.sqrt(-(rhox * fsd + x_data[i][j]) / (fc + rhox * fsd + x_data[i][j]))) * 180 / math.pi * 100) / 100 + " °<br><br>Regime 5:<br><i>x</i>-reinforcement yields in compression; Concrete crushes";
                    } else {
                        regime_text[i][j] = "α = " + math.round(math.acot(math.sqrt(-(rhox * fsd + x_data[i][j]) / (fc + rhox * fsd + x_data[i][j]))) * 180 / math.pi * 100) / 100 + " °<br><br>Regime 5:<br><i>x</i>-Bewehrung fliesst auf Druck; Beton bricht";
                    }
                }

                // Regime 6
                if (x_data[i][j] + y_data[i][j] < rhox * fsd - rhoz * fsd - fc && x_data[i][j] + y_data[i][j] >= -rhoz * fsd - rhox * fsd - fc && y_data[i][j] < -rhoz * fsd - fc / 2) {
                    z_data[i][j] = math.re(math.sqrt(-(rhoz * fsd + y_data[i][j]) * (fc + rhoz * fsd + y_data[i][j])));
                    regime_data[i][j] = 6;
                    if(lang == "en") {
                        regime_text[i][j] = "α = " + math.round(math.acot(math.sqrt(-(fc + rhoz * fsd + y_data[i][j]) / (rhoz * fsd + y_data[i][j]))) * 180 / math.pi * 100) / 100 + " °<br><br>Regime 6:<br><i>z</i>-reinforcement yields in compression; Concrete crushes";
                    } else {
                        regime_text[i][j] = "α = " + math.round(math.acot(math.sqrt(-(fc + rhoz * fsd + y_data[i][j]) / (rhoz * fsd + y_data[i][j]))) * 180 / math.pi * 100) / 100 + " °<br><br>Regime 6:<br><i>z</i>-Bewehrung fliesst auf Druck; Beton bricht";
                    }
                }

                // Regime 7
                if (x_data[i][j] + y_data[i][j] < -rhoz * fsd - rhox * fsd - fc) {
                    z_data[i][j] = math.re(math.sqrt((fc + rhox * fsd + x_data[i][j]) * (fc + rhoz * fsd + y_data[i][j])));
                    regime_data[i][j] = 7.5;
                    if(lang == "en") {
                        regime_text[i][j] = "α = " + math.round(math.acot(math.sqrt((fc + rhoz * fsd + y_data[i][j]) / (fc + rhox * fsd + x_data[i][j]))) * 180 / math.pi * 100) / 100 + " °<br><br>Regime 7:<br>Both reinforcements yield in compression; Concrete crushes";
                    } else {
                        regime_text[i][j] = "α = " + math.round(math.acot(math.sqrt((fc + rhoz * fsd + y_data[i][j]) / (fc + rhox * fsd + x_data[i][j]))) * 180 / math.pi * 100) / 100 + " °<br><br>Regime 7:<br>Beide Bewehrungen fliessen auf Druck; Beton bricht";
                    }
                }

            }
        }

    }

    var regime_ult_text = "";
    let txt_end = "";
    //Regime 1
    if (sigmax + sigmaz >= rhox * fsd + rhoz * fsd - fc) {
        if(lang == "en") {
            txt_end = " °<br><br></br>Regime 1:<br>Both reinforcements yield in tension.";
        } else {
            txt_end = " °<br><br></br>Regime 1:<br>Beide Bewehrungen fliessen auf Zug.";
        }
        regime_ult_text = "α = " + math.round(alpha_ult * 100) / 100 + txt_end;

    }
    // Regime 2
    if (sigmax + sigmaz < rhox * fsd + rhoz * fsd - fc && sigmaz >= rhoz * fsd - fc / 2 && sigmax + sigmaz >= rhoz * fsd - rhox * fsd - fc) {
        if(lang == "en") {
            txt_end = " °<br><br></br>Regime 2:<br><i>z</i>-reinforcement yields in tension; Concrete crushes";
        } else {
            txt_end = " °<br><br></br>Regime 2:<br><i>z</i>-Bewehrung fliesst auf Zug; Beton bricht";
        }
        regime_ult_text = "α = " + math.round(alpha_ult * 100) / 100 + txt_end;
    }

    // Regime 3
    if (sigmax + sigmaz < rhox * fsd + rhoz * fsd - fc && sigmax >= rhox * fsd - fc / 2 && sigmax + sigmaz >= rhox * fsd - rhoz * fsd - fc) {
        if(lang == "en") {
            txt_end = " °<br><br></br>Regime 3:<br><i>x</i>-reinforcement yields in tension; Concrete crushes";
        } else {
            txt_end = " °<br><br></br>Regime 3:<br><i>x</i>-Bewehrung fliesst auf Zug; Beton bricht";
        }
        regime_ult_text = "α = " + math.round(alpha_ult * 100) / 100 + txt_end;
    }

    // Regime 4
    if (sigmax < rhox * fsd - fc / 2 && sigmax >= -rhox * fsd - fc / 2 && sigmaz < rhoz * fsd - fc / 2 && sigmaz >= -rhoz * fsd - fc / 2) {
        if(lang == "en") {
            txt_end = " °<br><br></br>Regime 4:<br>Concrete crushes";
        } else {
            txt_end = " °<br><br></br>Regime 4:<br>Beton bricht";
        }
        regime_ult_text = "α = " + math.round(alpha_ult * 100) / 100 + txt_end;
    }

    // Regime 5
    if (sigmax + sigmaz < rhoz * fsd - rhox * fsd - fc && sigmax + sigmaz >= -rhoz * fsd - rhox * fsd - fc && sigmax < -rhox * fsd - fc / 2) {
        if(lang == "en") {
            txt_end = " °<br><br></br>Regime 5:<br><i>x</i>-reinforcement yields in compression; Concrete crushes";
        } else {
            txt_end = " °<br><br></br>Regime 5:<br><i>x</i>-Bewehrung fliesst auf Druck; Beton bricht";
        }
        regime_ult_text = "α = " + math.round(alpha_ult * 100) / 100 + txt_end;
    }

    // Regime 6
    if (sigmax + sigmaz < rhox * fsd - rhoz * fsd - fc && sigmax + sigmaz >= -rhoz * fsd - rhox * fsd - fc && sigmaz < -rhoz * fsd - fc / 2) {
        if(lang == "en") {
            txt_end = " °<br><br></br>Regime 6:<br><i>z</i>-reinforcement yields in compression; Concrete crushes";
        } else {
            txt_end = " °<br><br></br>Regime 6:<br><i>z</i>-Bewehrung fliesst auf Druck; Beton bricht";
        }
        regime_ult_text = "α = " + math.round(alpha_ult * 100) / 100 + txt_end;
    }

    // Regime 7
    if (sigmax + sigmaz < -rhoz * fsd - rhox * fsd - fc) {
        if(lang == "en") {
            txt_end = " °<br><br></br>Regime 7:<br>Both reinforcements yield in compression; Concrete crushes";
        } else {
            txt_end = " °<br><br></br>Regime 7:<br>Beide Bewehrungen fliessen auf Druck; Beton bricht";
        }
        regime_ult_text = "α = " + math.round(alpha_ult * 100) / 100 + txt_end;
    }

    if(lang == "en") {
        txt_end = "<b>State shown</b>:<br>" +
        "σ<sub><i>x</i></sub> = %{x:,.2f} MPa <br>" +
        "σ<sub><i>z</i></sub> = %{y:,.2f} MPa <br>" +
        "τ<sub><i>xz</i></sub> = %{z:,.2f} MPa <br>" +
        "%{customdata}";
    } else {
        txt_end = "<b>Dargestellter Zustand</b>:<br>" +
        "σ<sub><i>x</i></sub> = %{x:,.2f} MPa <br>" +
        "σ<sub><i>z</i></sub> = %{y:,.2f} MPa <br>" +
        "τ<sub><i>xz</i></sub> = %{z:,.2f} MPa <br>" +
        "%{customdata}";
    }

    var data = [
        {
            y: y_data,
            x: x_data,
            z: z_data,
            customdata: math.transpose(regime_text),
            name: "",
            hoverlabel: {
                bgcolor: "white",
                align: 'left',

            },
            hovertemplate:
                "σ<sub><i>x</i></sub> = %{x:,.2f} MPa <br>" +
                "σ<sub><i>z</i></sub> = %{y:,.2f} MPa <br>" +
                "τ<sub><i>xz</i></sub> = %{z:,.2f} MPa <br>" +
                "%{customdata}",
            type: 'surface',
            opacity: 0.7,
            surfacecolor: regime_data,
            colorbar: {
                title: 'Regime'
            },
            colorscale: [
                ['0.0', 'rgb(0,255,0)'],
                ['0.143', 'rgb(0,255,0)'],
                ['0.143', 'rgb(255,0,0)'],
                ['0.286', 'rgb(255,0,0)'],
                ['0.286', 'rgb(0,0,255)'],
                ['0.429', 'rgb(0,0,255)'],
                ['0.429', 'rgb(0,255,255)'],
                ['0.571', 'rgb(0,255,255)'],
                ['0.571', 'rgb(255,0,255)'],
                ['0.714', 'rgb(255,0,255)'],
                ['0.714', 'rgb(255,255,0)'],
                ['0.857', 'rgb(255,255,0)'],
                ['0.857', 'rgb(50,100,100)'],
                ['1.0', 'rgb(50,100,100)']
            ]
        },
        // ultimate load
        {
            x: [sigmax], y: [sigmaz], z: [tauxz_ult],
            
            hoverinfo: 'none',
            mode: 'markers',
            name: "",
            marker: {
                size: 7,
                color: ['rgb(200,200,200)'],
                opacity: 1,
                line: {
                    color: 'rgb(0,0,0)',
                    width: 20,
                },
            },
            type: 'scatter3d'
        },
        // ultimate load transparent
        {
            x: [sigmax], y: [sigmaz], z: [tauxz_ult],
            customdata: [regime_ult_text],
            mode: 'markers',
            name: "",
            hoverlabel: {
                bgcolor: "black"
            },
            hovertemplate: txt_end,
            marker: {
                size: 20,
                color: ['rgb(255,255,255)'],
                opacity: 0.001,
            },
            type: 'scatter3d'
        }];
    if (init == 1) {
        init = 0;
        var layout = {
            //title: 'Fliessfigur',
            autosize: true,
            height: 350,
            margin: {
                l: 0,
                r: 0,
                b: 0,
                t: 0,
                pad: 0
            },

            scene: {
                aspectmode: "manual",
                aspectratio: {
                    x: 1, y: 1, z: 1,
                },
                xaxis: {
                    title: 'σ<sub>x</sub> [MPa]',
                    nticks: 10,
                    range: [-math.max(rhox, rhoz) * fsd - fc, math.max(rhox, rhoz) * fsd],
                },
                yaxis: {
                    title: 'σ<sub>z</sub> [MPa]',
                    nticks: 10,
                    range: [-math.max(rhox, rhoz) * fsd - fc, math.max(rhox, rhoz) * fsd],
                },
                zaxis: {
                    title: 'τ<sub>xz</sub> [MPa]',
                    nticks: 10,
                    range: [0, fc],
                },
                camera: {
                    center: {
                        x: 0, y: 0, z: 0
                    },
                    eye: {
                        x: 0, y: 0, z: 1.25
                    },//(2*math.max(rhox,rhoz)*fsd+fc)/0.01},
                    up: {
                        x: -1, y: 0, z: 1
                    },
                    projection: {
                        type: "orthographic"
                    }
                }
            },

        };


        Plotly.newPlot('plot_3D', data, layout, config);
    } else {
        Plotly.restyle("plot_3D", {
            x: [x_data, [sigmax],[sigmax]],
            y: [y_data, [sigmaz],[sigmaz]],
            z: [z_data, [tauxz_ult],[tauxz_ult]],
            customdata: [math.transpose(regime_text),[], [regime_ult_text]],
            surfacecolor: [regime_data, [],[]],
        });

        Plotly.relayout("plot_3D", {
            'scene.xaxis.range': [-math.max(rhox, rhoz) * fsd - fc, math.max(rhox, rhoz) * fsd],
            'scene.yaxis.range': [-math.max(rhox, rhoz) * fsd - fc, math.max(rhox, rhoz) * fsd],
            'scene.zaxis.range': [0, fc],
        }
        )
    }
    rhox_old = rhox;
    rhoz_old = rhoz;
    fsd_old = fsd;
    fc_old = fc;
}


function plotElement() {


    let rhoxr = math.round(rhox * 1000) / 1000;
    let rhozr = math.round(rhoz * 1000) / 1000;

    // Define Drawing parameters
    let arrow_scale = 0.5;
    let arrow_head_length = 0.4; // value manually extracted from on draw.lib
    let arrow_length_scale = 0.1;
    let gap = 0.1;

    /*
    Draw conventions
     */

    let maximumvaluesclae = math.divide(3.5, math.max(math.abs(sigmax), math.abs(sigmaz), math.abs(tauxz_ult), 3.5)); // this value avoids arrows drawn outside of the field of view.
    let temp_xzElement = new Group();

    if (sigmax <= rhoxr * fsd && sigmax >= -fc - rhoxr * fsd && sigmaz <= rhozr * fsd && sigmaz >= -fc - rhozr * fsd) {
        temp_xzElement.addElm(new Rectangle(1, 1, 0, 0).setFill(col.sf_bg.getRgba()));

        // reinforcement
        let density = 1 / 0.8; // amount of reinforcement bars for 1%

        // x
        let s = 1 / (2 * rhoxr * density * 100);
        let n = math.floor(1 / s - 0.00000001);
        if (n > 0 || rhoxr < 0.00000001) {
            for (var i = 0; i < rhoxr * density * 100 * 2 - 1; i++) {
                temp_xzElement.addElm(new Rectangle(1, 0.01, 0, i * s - 0.5 + (1 - (n - 1) * s) / 2).setFill(col.s.getRgba()).setColor(col.s.getRgb()));
            }
        } else {
            temp_xzElement.addElm(new Rectangle(1, 0.01, 0, 0).setFill(col.s.getRgba()).setColor(col.s.getRgb()));
        }

        // z
        s = 1 / (2 * rhozr * density * 100);
        n = math.floor(1 / s - 0.00000001);
        if (n > 0 || rhozr < 0.00000001) {
            for (var i = 0; i < rhozr * density * 100 * 2 - 1; i++) {
                temp_xzElement.addElm(new Rectangle(0.01, 1, i * s - 0.5 + (1 - (n - 1) * s) / 2, 0).setFill(col.s.getRgba()).setColor(col.s.getRgb()));
            }
        } else {
            temp_xzElement.addElm(new Rectangle(0.01, 1, 0, 0).setFill(col.s.getRgba()).setColor(col.s.getRgb()));

        }

        // crack1

        let crackline = new Group();
        let wavelength = 0.05;
        let x = -math.sqrt(2) / 2;
        let res = 0.005;


        let x1_i, y1_i
        let x2_i, y2_i;
        let x3_i, y3_i;

        let x1 = math.dotMultiply(math.ones(math.round(math.sqrt(2) / res + 1)), NaN);
        let y1 = math.dotMultiply(math.ones(math.round(math.sqrt(2) / res + 1)), NaN);
        let i1 = 0;

        let x2 = math.dotMultiply(math.ones(math.round(math.sqrt(2) / res + 1)), NaN);
        let y2 = math.dotMultiply(math.ones(math.round(math.sqrt(2) / res + 1)), NaN);
        let i2 = 0;

        let x3 = math.dotMultiply(math.ones(math.round(math.sqrt(2) / res + 1)), NaN);
        let y3 = math.dotMultiply(math.ones(math.round(math.sqrt(2) / res + 1)), NaN);
        let i3 = 0;


        for (let i = 0; x <= math.sqrt(2) / 2; i++) {

            //crack1
            x1_i = math.cos(alpha_ult / 180 * math.pi) * x - math.sin(alpha_ult / 180 * math.pi) * math.sin(x / wavelength * 2 * math.pi) * wavelength / 4;
            y1_i = math.sin(alpha_ult / 180 * math.pi) * x + math.cos(alpha_ult / 180 * math.pi) * math.sin(x / wavelength * 2 * math.pi) * wavelength / 4;

            if (x1_i < 0.5 && x1_i > -0.5 && y1_i < 0.5 && y1_i > -0.5) {
                x1._data[i1] = x1_i;
                y1._data[i1] = y1_i;
                i1 = i1 + 1;
            }

            //crack2
            x2_i = math.cos(alpha_ult / 180 * math.pi) * x - math.sin(alpha_ult / 180 * math.pi) * (math.sin(x / wavelength * 2 * math.pi) * wavelength / 4 + math.sqrt(2) / 4);
            y2_i = math.sin(alpha_ult / 180 * math.pi) * x + math.cos(alpha_ult / 180 * math.pi) * (math.sin(x / wavelength * 2 * math.pi) * wavelength / 4 + math.sqrt(2) / 4);

            if (x2_i < 0.5 && x2_i > -0.5 && y2_i < 0.5 && y2_i > -0.5) {
                x2._data[i2] = x2_i;
                y2._data[i2] = y2_i;
                i2 = i2 + 1;
            }

            //crack3
            x3_i = math.cos(alpha_ult / 180 * math.pi) * x - math.sin(alpha_ult / 180 * math.pi) * (math.sin(x / wavelength * 2 * math.pi) * wavelength / 4 - math.sqrt(2) / 4);
            y3_i = math.sin(alpha_ult / 180 * math.pi) * x + math.cos(alpha_ult / 180 * math.pi) * (math.sin(x / wavelength * 2 * math.pi) * wavelength / 4 - math.sqrt(2) / 4);

            if (x3_i < 0.5 && x3_i > -0.5 && y3_i < 0.5 && y3_i > -0.5) {
                x3._data[i3] = x3_i;
                y3._data[i3] = y3_i;
                i3 = i3 + 1;
            }

            x = x + res;
        }

        crackline.addElm(new Line(x1._data, y1._data).setColor(col.base.getRgb()).setDash('solid'));
        crackline.addElm(new Line(x2._data, y2._data).setColor(col.base.getRgb()).setDash('solid'));
        crackline.addElm(new Line(x3._data, y3._data).setColor(col.base.getRgb()).setDash('solid'));


        temp_xzElement.addElm(crackline);



        // angle
        temp_xzElement.addElm(new Circle(0, 0, 0.3, alpha_ult).rotate(180));
        let phiround = math.round(alpha_ult * 10) / 10;
        temp_xzElement.addElm(new Rectangle(0.07, 0.07, -math.cos(-alpha_ult / 180 / 2 * math.pi) * 0.4, -math.sin(alpha_ult / 180 / 2 * math.pi) * 0.4).setColor(col.bg.getRgb()).setFill(col.bg.getRgba()));
        temp_xzElement.addElm(new Text(-math.cos(-alpha_ult / 180 / 2 * math.pi) * 0.4, -math.sin(alpha_ult / 180 / 2 * math.pi) * 0.4, ["α"]));
        temp_xzElement.addElm(new Line([0, -0.4], [0, 0]).setColor(col.base.getRgb()).setDash('dot'));


        // forces
        if (sigmax !== 0) {

            let arrowlength = math.abs(sigmax) * maximumvaluesclae * arrow_length_scale + arrow_scale * arrow_head_length;

            // xz-Element
            temp_xzElement.addElm(new Arrow(0.5 + gap, 0, arrowlength, 0, arrow_scale).rotate(-90, 0.5 + gap, 0).rotate((math.sign(sigmax) + 1) / 2 * 180, 0.5 + gap + arrowlength / 2, 0).setColor(col.forces.getRgb()).setFill(col.forces.getRgba()));
            temp_xzElement.addElm(new Arrow(-(0.5 + gap), 0, arrowlength, 0, arrow_scale).rotate(90, -(0.5 + gap), 0).rotate((math.sign(sigmax) + 1) / 2 * 180, -(0.5 + gap + arrowlength / 2), 0).setColor(col.forces.getRgb()).setFill(col.forces.getRgba()));

        }

        if (sigmaz !== 0) {

            let arrowlength = math.abs(sigmaz) * maximumvaluesclae * arrow_length_scale + arrow_scale * arrow_head_length;

            // xz-Element
            temp_xzElement.addElm(new Arrow(0, -(0.5 + gap + arrowlength), arrowlength, 0, arrow_scale).rotate((math.sign(sigmaz) - 1) / 2 * 180, 0, -(0.5 + gap + arrowlength / 2)).setColor(col.forces.getRgb()).setFill(col.forces.getRgba()));
            temp_xzElement.addElm(new Arrow(0, (0.5 + gap), arrowlength, 0, arrow_scale).rotate(-(math.sign(sigmaz) + 1) / 2 * 180, 0, (0.5 + gap + arrowlength / 2)).setColor(col.forces.getRgb()).setFill(col.forces.getRgba()));

        }

        if (tauxz_ult !== 0) {

            let arrowlength = math.abs(tauxz_ult) * maximumvaluesclae * arrow_length_scale + arrow_scale * arrow_head_length;

            // xz-Element
            temp_xzElement.addElm(new Arrow(0.5 + gap, -arrowlength / 2, arrowlength, 0, arrow_scale).rotate(-(math.sign(tauxz_ult) - 1) / 2 * 180, 0.5 + gap, 0).setColor(col.forces.getRgb()).setFill(col.forces.getRgba()));
            temp_xzElement.addElm(new Arrow(-(0.5 + gap), -arrowlength / 2, arrowlength, 0, arrow_scale).rotate(-(math.sign(tauxz_ult) + 1) / 2 * 180, -(0.5 + gap), 0).setColor(col.forces.getRgb()).setFill(col.forces.getRgba()));
            temp_xzElement.addElm(new Arrow(arrowlength / 2, -(0.5 + gap), arrowlength, 0, arrow_scale).rotate(90, arrowlength / 2, -(0.5 + gap)).rotate(-(math.sign(tauxz_ult) - 1) / 2 * 180, 0, -(0.5 + gap)).setColor(col.forces.getRgb()).setFill(col.forces.getRgba()));
            temp_xzElement.addElm(new Arrow(-arrowlength / 2, (0.5 + gap), arrowlength, 0, arrow_scale).rotate(-90, -arrowlength / 2, (0.5 + gap)).rotate(-(math.sign(tauxz_ult) - 1) / 2 * 180, 0, (0.5 + gap)).setColor(col.forces.getRgb()).setFill(col.forces.getRgba()));
        }

        // Coordinate System
        temp_xzElement.addElm(new Arrow(0, -0.4, 0.4, 0, arrow_scale * 0.5).setFill(col.base.getRgba()).rotate(90, 0, 0));
        temp_xzElement.addElm(new Arrow(0, -0.4, 0.4, 0, arrow_scale * 0.5).setFill(col.base.getRgba()).rotate(0, 0, 0));
        temp_xzElement.addElm(new Rectangle(0.07, 0.07, 0.45, 0).setColor(col.bg.getRgb()).setFill(col.bg.getRgba()));
        temp_xzElement.addElm(new Text(0.45, 0, "<i>x</i>"));
        temp_xzElement.addElm(new Rectangle(0.07, 0.07, 0, -0.45).setColor(col.bg.getRgb()).setFill(col.bg.getRgba()));
        temp_xzElement.addElm(new Text(0, -0.45, "<i>z</i>"));


        // transparent line
        temp_xzElement.addElm(new Line([-1.2, 1.2], [-1.2, 1.2]).setWidth(0));

    }
    /*
    Layouts
     */
    let layout_Element = {
        hovermode: false,
        height: 350,
        //width: 700,
        //autosize: false,
        margin: {
            l: 0,
            r: 0,
            b: 0,
            t: 0,
            pad: 0
        },
        xaxis: {

            domain: [0, 1],
            autorange: true,
            showgrid: false,
            zeroline: false,
            showline: false,
            autotick: true,
            ticks: '',
            showticklabels: false,
        },
        yaxis: {

            domain: [0, 1],
            autorange: true,
            showgrid: false,
            zeroline: false,
            showline: false,
            autotick: true,
            ticks: '',
            showticklabels: false,
            scaleanchor: "x",
            scaleratio: 1,
        },
        showlegend: false,
    };

    // Plot XZ-Element
    let pltSec = temp_xzElement.getPlotData();
    var data = pltSec.data;
    Plotly.newPlot('plot_Element', data, layout_Element, { staticPlot: true, responsive: true });


}





/********************************
 *      Main
 ********************************/
updCalc();
updPlots();
updateHTML();